import { ProductType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all products
export const getProducts = async (branch_id?: string | number) => {
  const url = branch_id
    ? `${ServiceEndpoints.PRODUCT}?branch_id=${branch_id}`
    : ServiceEndpoints.PRODUCT;

  return axios
    .get(url)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new product
export const createProduct = async (data: FormData) => {
  return axios
    .post(ServiceEndpoints.PRODUCT, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create products by uploading excel or csv files
export const bulkProductCreate = async (data: any) => {
  return axios
    .post(ServiceEndpoints.BULK_PRODUCT, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update a product by ID
export const updateProduct = async (id: string, data: ProductType) => {
  const { ...productData } = data;

  return axios
    .put(`${ServiceEndpoints.PRODUCT}/${id}`, productData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a product by its ID
export const getProductById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.PRODUCT}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a product by ID
export const deleteProduct = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.PRODUCT}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
